import React from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  Form,
  Button,
  Accordion,
  Card,
} from "react-bootstrap";
import { css } from "aphrodite";
import styles from "../style";
import CustomRadioButton from "../../GenericComponents/CustomRadioButton";
import CustomModal from "../../GenericComponents/CustomModal";
import CustomAccordion from "../../GenericComponents/CustomAccordion";
import DayTimeSettingsCard from "./DayTimeSettingsCard";
import NightTimeSettingsCard from "./NightTimeSettingsCard";
import AudioRecordingCard from "./AudioRecordingCard";
import DeviceAlarmSelect from "../DeviceAlarmSelect";
import { DeviceForAlarmRingTone } from "../../../lib/constant";
import "./AbnormalMotion.css";

class AbnormalMotion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      changeSmartwatchSettings: false,
      changeSnoozeSettings: false,
      changeAlarmSettings: false,
      allowSettingChangeOnSmartWatch: false,
      allowSnoozeOnSmartWatch: false,
      enableAbnormalMotionAlarmRingTone: false,
      showDTSModal: false,
      showNTSModal: false,
      showAudioRecordingModal: false,
      showAlarmRingtoneModal: false,
      handleSettingsAlert: false,
      handleSnoozeAlert: false,
      handleAlarmAlert: false,
      snoozeComp: false,
      alarmComp: false,
      audioComp: false,
      enableUpdateFlag: false,
      updateSettings: false,
      enableMotionMonitoring: false,
    };
  }

  componentDidMount = () => {
    let activeModules = this.props.appModules.active;
    let inactiveModules = this.props.appModules.inactive;
    let snoozeComp =
      activeModules.SD && activeModules.SD.includes("SNOOZE_TRIGGER")
        ? true
        : inactiveModules.SD && inactiveModules.SD.includes("SNOOZE_TRIGGER")
          ? false
          : undefined;

    let alarmComp =
      activeModules.SD && activeModules.SD.includes("TRIGGER_ALARM")
        ? true
        : inactiveModules.SD && inactiveModules.SD.includes("TRIGGER_ALARM")
          ? false
          : undefined;

    let audioComp =
      activeModules?.ADORE && activeModules?.ADORE.includes("RECORD_AUDIO") || activeModules?.SD && activeModules?.SD.includes("RECORD_AUDIO")
        ? true
        : inactiveModules?.ADORE &&
          inactiveModules?.ADORE.includes("RECORD_AUDIO") || inactiveModules?.SD &&
          inactiveModules?.SD.includes("RECORD_AUDIO")
          ? false
          : undefined;

    this.setState({ snoozeComp, alarmComp, audioComp });
  };

  setTime = (fieldName, date) => {
    let abnormalMotionSettings = this.props.abnormalMotionSettings;
    abnormalMotionSettings[fieldName] = moment(date).format("HH:mm");

    switch (fieldName) {
      case "dayTimeStart":
        abnormalMotionSettings.nightTimeEnd = moment(date).format("HH:mm");
        break;
      case "dayTimeEnd":
        abnormalMotionSettings.nightTimeStart = moment(date).format("HH:mm");
        break;
      case "nightTimeStart":
        abnormalMotionSettings.dayTimeEnd = moment(date).format("HH:mm");
        break;
      case "nightTimeEnd":
        abnormalMotionSettings.dayTimeStart = moment(date).format("HH:mm");
        break;
    }

    this.setState({ enableUpdateFlag: true }, () =>
      this.props.setAbnormalSettingsData(abnormalMotionSettings)
    );
  };

  handleSliderValues = (fieldName, value) => {
    let abnormalMotionSettings = this.props.abnormalMotionSettings;
    abnormalMotionSettings[fieldName] = value;
    this.setState({ enableUpdateFlag: true }, () => {
      this.props.setAbnormalSettingsData(abnormalMotionSettings);
    });
  };

  handleChanges = (fieldName, value) => {
    let abnormalMotionSettings = this.props.abnormalMotionSettings;
    abnormalMotionSettings[fieldName] = value.target.checked;
    this.setState(
      { enableUpdateFlag: true, [fieldName]: value.target.checked },
      () => {
        this.props.setAbnormalSettingsData(abnormalMotionSettings);
      }
    );
  };

  handleSettingChanges = (fieldName, value) => {
    let abnormalMotionSettings = this.props.abnormalMotionSettings;
    abnormalMotionSettings[fieldName] = value;
    this.setState({ enableUpdateFlag: true, [fieldName]: false }, () => {
      this.props.setAbnormalSettingsData(abnormalMotionSettings);
    });
  };

  saveData = () => {
    this.setState({ updateSettings: !this.state.updateSettings });
  };

  handleUpdate = (fieldName, value) => {
    this.setState({ updateSettings: !this.state.updateSettings }, () => {
      value &&
        this.props.updateAbnormalMotionSettings(
          this.props.abnormalMotionSettings
        );
    });
  };

  resetDayTimeSettings = () => {
    let amSettings = { ...this.props.abnormalMotionSettings };
    amSettings.dayTimeStart =
      this.props.defaultSettings.DAY_TIME_START.defaultValue;
    amSettings.dayTimeEnd =
      this.props.defaultSettings.DAY_TIME_END.defaultValue;
    amSettings.dayTimeSensitivity = parseInt(
      this.props.defaultSettings.DAY_SENSITIVITY.defaultValue
    );
    amSettings.dayTimeDuration = parseInt(
      this.props.defaultSettings.DAY_DURATION.defaultValue
    );
    amSettings.nightTimeStart =
      this.props.defaultSettings.NIGHT_TIME_START.defaultValue;
    amSettings.nightTimeEnd =
      this.props.defaultSettings.NIGHT_TIME_END.defaultValue;

    this.setState({ enableUpdateFlag: true }, () => {
      this.props.setAbnormalSettingsData(amSettings);
    });
  };

  resetNightTimeSettings = () => {
    let amSettings = { ...this.props.abnormalMotionSettings };
    amSettings.nightTimeStart =
      this.props.defaultSettings.NIGHT_TIME_START.defaultValue;
    amSettings.nightTimeEnd =
      this.props.defaultSettings.NIGHT_TIME_END.defaultValue;
    amSettings.nightTimeSensitivity = parseInt(
      this.props.defaultSettings.NIGHT_SENSITIVITY.defaultValue
    );
    amSettings.nightTimeDuration = parseInt(
      this.props.defaultSettings.NIGHT_DURATION.defaultValue
    );
    amSettings.dayTimeStart =
      this.props.defaultSettings.DAY_TIME_START.defaultValue;
    amSettings.dayTimeEnd =
      this.props.defaultSettings.DAY_TIME_END.defaultValue;

    this.setState({ enableUpdateFlag: true }, () => {
      this.props.setAbnormalSettingsData(amSettings);
    });
  };

  resetAudioSettings = () => {
    let amSettings = { ...this.props.abnormalMotionSettings };
    amSettings.enableAudioRecording =
      this.props.defaultSettings.AUDIO_RECORDING.defaultValue === "true";
    amSettings.audioRecordingDuration = parseInt(
      this.props.defaultSettings.AUDIO_RECORD_DURATION.defaultValue
    );

    this.setState({ enableUpdateFlag: true }, () => {
      this.props.setAbnormalSettingsData(amSettings);
    });
  };

  render() {
    const { abnormalMotionSettings, defaultSettings, appModules, user } = this.props;
    const isReadOnly = user?.roleId === 10;

    return (
      <container>
        <CustomModal
          header={"Alert"}
          name={"enableMotionMonitoring"}
          size={"sm"}
          title={"Are you sure to enable the Motion Monitoring?"}
          show={this.state.enableMotionMonitoring}
          action={this.handleSettingChanges}
        />
        <CustomModal
          header={"Alert"}
          name={"allowSettingChangeOnSmartWatch"}
          size={"sm"}
          title={
            "Are you sure to enable the Allow Setting Change On Smartwatch"
          }
          show={this.state.allowSettingChangeOnSmartWatch}
          action={this.handleSettingChanges}
        />
        <CustomModal
          header={"Alert"}
          name={"allowSnoozeOnSmartWatch"}
          size={"sm"}
          title={
            "Are you sure to enable the Allow Snooze trun On/Off On Smartwatch"
          }
          show={this.state.allowSnoozeOnSmartWatch}
          action={this.handleSettingChanges}
        />
        <CustomModal
          header={"Alert"}
          name={"enableAbnormalMotionAlarmRingTone"}
          size={"sm"}
          title={"Are you sure to Enable Alarm Ringtone For Motion Monitoring"}
          show={this.state.enableAbnormalMotionAlarmRingTone}
          action={this.handleSettingChanges}
        />
        <CustomModal
          header={"Confirm"}
          name={"updateSettings"}
          size={"sm"}
          title={"Are you sure you want to save the details ?"}
          show={this.state.updateSettings}
          action={this.handleUpdate}
        />
        <div className="monitoring-settings-content">
          <div className={css(styles.header)}>{"Motion Monitoring"}</div>
          <Form>
            <Form.Group className={css(styles.formGroupStyles)}>
              <Form.Label className={css(styles.settingLabels)}>
                Enable Motion Monitoring
              </Form.Label>

              <CustomRadioButton
                name={"enableMotionMonitoring"}
                type={"switch"}
                inline={true}
                label={""}
                checked={abnormalMotionSettings.enableMotionMonitoring}
                action={this.handleChanges}
              />
            </Form.Group>
            <Form.Group className={css(styles.formGroupStyles)}>
              <Form.Label
                className={
                  user.entityMaster?.shortName === "SIH"
                    ? css(styles.disabledLabels)
                    : css(styles.settingLabels)
                }
              >
                Allow settings change on smartwatch
              </Form.Label>

              <CustomRadioButton
                name={"allowSettingChangeOnSmartWatch"}
                type={"switch"}
                inline={true}
                label={""}
                checked={abnormalMotionSettings.allowSettingChangeOnSmartWatch}
                action={this.handleChanges}
                disabled={user.entityMaster?.shortName === "SIH" || isReadOnly}
              />
            </Form.Group>
            {this.state.snoozeComp !== undefined ? (
              <Form.Group className={css(styles.formGroupStyles)}>
                <Form.Label
                  className={
                    this.state.snoozeComp
                      ? css(styles.settingLabels)
                      : css(styles.disabledLabels)
                  }
                >
                  Allow snooze turn on/off on smartwatch <br />
                  {!this.state.snoozeComp && (
                    <label className={css(styles.infoLabels)}>
                      Not included in your current subscription plan, please
                      upgrade your subscription
                    </label>
                  )}
                </Form.Label>

                <CustomRadioButton
                  name={"allowSnoozeOnSmartWatch"}
                  type={"switch"}
                  inline={true}
                  label={""}
                  checked={abnormalMotionSettings.allowSnoozeOnSmartWatch}
                  action={this.handleChanges}
                  disabled={!this.state.snoozeComp || isReadOnly}
                />
              </Form.Group>
            ) : null}
            {this.state.alarmComp !== undefined ? (
              <Form.Group className={css(styles.formGroupStyles)}>
                <Form.Label
                  className={
                    this.state.alarmComp
                      ? css(styles.settingLabels)
                      : css(styles.disabledLabels)
                  }
                >
                  Audible Alarm <br />
                  {!this.state.alarmComp && (
                    <label className={css(styles.infoLabels)}>
                      Not included in your current subscription plan, please
                      upgrade your subscription
                    </label>
                  )}
                </Form.Label>
                <DeviceAlarmSelect
                  aria-label="Select device type"
                  value={
                    abnormalMotionSettings.deviceForAlarmRingTone ||
                    DeviceForAlarmRingTone.none
                  }
                  onChange={(val) =>
                    this.handleSettingChanges("deviceForAlarmRingTone", val)
                  }
                  disabled={!this.state.alarmComp || isReadOnly}
                />
              </Form.Group>
            ) : null}
            <Accordion defaultActiveKey="0" flush>
              <Card style={{ marginBottom: "1em" }}>
                <Card.Header className={css(styles.cardHeaderStyle)}>
                  <Form.Group className={css(styles.formGroupStylesNew)}>
                    <Form.Label className={css(styles.settingLabels, styles.settingCardLabels)}>
                      Day time monitoring <br />
                      <span className={css(styles.subLabels)}>
                        Settings will be used to monitor motion events on your
                        device during <b>Day Time</b> hours you have setup.
                      </span>
                      <br />
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#76787a",
                          textTransform: "initial",
                        }}
                      >
                        Motion sensitivity set at{" "}
                        {abnormalMotionSettings.dayTimeSensitivity}
                      </span>
                      <br />
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#76787a",
                          textTransform: "initial",
                        }}
                      >
                        Motion Duration for event trigger set at{" "}
                        {`${abnormalMotionSettings.dayTimeDuration} ${defaultSettings.DAY_DURATION.unit}`}
                      </span>
                    </Form.Label>
                    {!isReadOnly && (
                      <div className={css(styles.settingActionButtons)}>
                        <div style={{ marginBottom: "10px" }}>
                          <CustomAccordion eventKey="edit-btn1">
                            <Button
                              //variant="secondary"
                              type="button"
                              id="edit-btn1"
                              className="editButtonStyles"
                            >
                              Edit
                            </Button>
                          </CustomAccordion>
                        </div>
                        <div>
                          <Accordion.Collapse eventKey="edit-btn1">
                            <Button
                              variant="primary"
                              type="button"
                              className="editButtonStyles"
                              onClick={() => this.resetDayTimeSettings()}
                            >
                              Reset to Defaults
                            </Button>
                          </Accordion.Collapse>
                        </div>
                      </div>
                    )}
                  </Form.Group>
                </Card.Header>
                <Accordion.Collapse eventKey="edit-btn1">
                  <Card.Body>
                    <DayTimeSettingsCard
                      dayTimeSettings={abnormalMotionSettings}
                      defaultSettings={defaultSettings}
                      setTime={this.setTime}
                      handleSliderValues={this.handleSliderValues}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </Card>

              <Card style={{ marginBottom: "1em" }}>
                <Card.Header className={css(styles.cardHeaderStyle)}>
                  <Form.Group className={css(styles.formGroupStylesNew)}>
                    <Form.Label className={css(styles.settingLabels, styles.settingCardLabels)}>
                      Night time monitoring <br />
                      <span className={css(styles.subLabels)}>
                        Settings will be used to monitor motion events on your
                        device during <b>Night Time</b> hours you have setup.
                      </span>
                      <br />
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#76787a",
                          textTransform: "initial",
                        }}
                      >
                        Motion sensitivity set at{" "}
                        {abnormalMotionSettings.nightTimeSensitivity}
                      </span>
                      <br />
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#76787a",
                          textTransform: "initial",
                        }}
                      >
                        Motion Duration for event trigger set at{" "}
                        {`${abnormalMotionSettings.nightTimeDuration} ${defaultSettings.NIGHT_DURATION.unit}`}
                      </span>
                    </Form.Label>
                    {!isReadOnly && (
                      <div className={css(styles.settingActionButtons)}>
                        <div style={{ marginBottom: "10px" }}>
                          <CustomAccordion eventKey="edit-btn2">
                            <Button
                              //variant="secondary"
                              type="button"
                              id="edit-btn2"
                              className="editButtonStyles"
                            >
                              Edit
                            </Button>
                          </CustomAccordion>
                        </div>
                        <div>
                          <Accordion.Collapse eventKey="edit-btn2">
                            <Button
                              variant="primary"
                              type="button"
                              className="editButtonStyles"
                              onClick={() => this.resetNightTimeSettings()}
                            >
                              Reset to Defaults
                            </Button>
                          </Accordion.Collapse>
                        </div>
                      </div>
                    )}
                  </Form.Group>
                </Card.Header>
                <Accordion.Collapse eventKey="edit-btn2">
                  <Card.Body>
                    <NightTimeSettingsCard
                      nightTimeSettings={abnormalMotionSettings}
                      defaultSettings={defaultSettings}
                      setTime={this.setTime}
                      handleSliderValues={this.handleSliderValues}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              {this.state.audioComp !== undefined ? (
                <Card style={{ marginBottom: "1em" }}>
                  <Card.Header className={css(styles.cardHeaderStyle)}>
                    <Form.Group className={css(styles.formGroupStylesNew)}>
                      <Form.Label
                        className={
                          this.state.audioComp
                            ? css(styles.settingLabels, styles.settingCardLabels)
                            : css(styles.disabledLabels, styles.settingCardLabels)
                        }
                      >
                        Audio recording <br />
                        {this.state.audioComp ? (
                          <div>
                            <span className={css(styles.subLabels)}>
                              Once enabled, your device will record Audio during
                              and after the event for the duration you have set.
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "14px",
                                color: "#76787a",
                                textTransform: "initial",
                              }}
                            >
                              Recording set for during the event and for{" "}
                              {`${abnormalMotionSettings.audioRecordingDuration} ${defaultSettings.AUDIO_RECORD_DURATION.unit}`}{" "}
                              after the event
                            </span>
                          </div>
                        ) : (
                          <label className={css(styles.infoLabels)}>
                            Not included in your current subscription plan,
                            please upgrade your subscription
                          </label>
                        )}
                      </Form.Label>
                      {this.state.audioComp
                        ? !isReadOnly && (
                            <div className={css(styles.settingActionButtons)}>
                              <div style={{ marginBottom: "10px" }}>
                                <CustomAccordion eventKey="edit-btn3">
                                  <Button
                                    //variant="secondary"
                                    type="button"
                                    id="edit-btn3"
                                    className="editButtonStyles"
                                  >
                                    Edit
                                  </Button>
                                </CustomAccordion>
                              </div>
                              <div>
                                <Accordion.Collapse eventKey="edit-btn3">
                                  <Button
                                    variant="primary"
                                    type="button"
                                    className="editButtonStyles"
                                    onClick={() => this.resetAudioSettings()}
                                  >
                                    Reset to Defaults
                                  </Button>
                                </Accordion.Collapse>
                              </div>
                            </div>
                          )
                        : !isReadOnly && (
                            <Button
                              type="button"
                              className="editButtonStyles"
                              disabled={true}
                            >
                              Edit
                            </Button>
                          )}
                    </Form.Group>
                  </Card.Header>
                  <Accordion.Collapse eventKey="edit-btn3">
                    <Card.Body>
                      <AudioRecordingCard
                        audioSettings={abnormalMotionSettings}
                        defaultSettings={defaultSettings}
                        handleChanges={this.handleChanges}
                        handleSliderValues={this.handleSliderValues}
                      />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ) : null}

              {/* <Card style={{ marginBottom: "1em" }}>
                <Card.Header className={css(styles.cardHeaderStyle)}>
                  <Form.Group className={css(styles.formGroupStylesNew)}>
                    <Form.Label className={css(styles.settingLabels)}>
                      Alarm tone <br />
                      <span style={{fontSize: "14px", color: "#76787a" }}>signal ringtone</span>
                      <br />
                    </Form.Label>
                    <CustomAccordion eventKey="edit-btn4">
                      <Button
                        type="button"
                        id="edit-btn4"
                        className="editButtonStyles"
                      >
                        Edit
                      </Button>
                    </CustomAccordion>
                  </Form.Group>
                </Card.Header>
                <Accordion.Collapse eventKey="edit-btn4">
                  <Card.Body>
                    <AlarmRingtoneCard
                      audioSettings={abnormalMotionSettings}
                      defaultSettings={defaultSettings}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </Card> */}
            </Accordion>

            <div style={{ marginTop: "2em", textAlign: "center" }}>
              {!isReadOnly && (
                <Button
                  variant="primary"
                  type="button"
                  className={css(styles.updateButtonStyles)}
                  style={{ marginRight: "10px" }}
                  disabled={!this.state.enableUpdateFlag}
                  onClick={() => this.saveData()}
                >
                  Update
                </Button>
              )}
              <Button
                variant="secondary"
                type="button"
                className={css(styles.updateButtonStyles)}
                onClick={() => this.props.closeSettings()}
              >
                Close
              </Button>
            </div>
          </Form>
        </div>
      </container>
    );
  }
}

export default connect(
  (store) => {
    return {
      abnormalMotionSettings: store.settings.abnormalMotionSettings,
      appModules: store.dashboard.appModules,
      user: store.user
    };
  },
  (dispatch) => {
    return {};
  }
)(withRouter(AbnormalMotion));
